import React from "react";
import Layout from "../containers/layout";
import {graphql, Link} from "gatsby";
import GraphQLErrorList from "../components/graphql-error-list";
import StoryPreview from "../components/story-preview";
import SEO from "../components/seo";

export const blogListQuery = graphql`
query blogListQuery($skip: Int!, $limit: Int!) {
    allSanityEsStories(
        sort: {order: DESC, fields: publishedAt}
        limit: $limit
        skip: $skip
        ){
        edges {
           node {
            subtitle
             id
            publishedAt
            mainImage {
            asset {
                _id 
                } 
               }
            title
            slug {current}
            writer {name}
            entity
        }
        }
    }
}
`;


const esStoriesListBuilder = props => {
    const { pageContext, errors } = props;
    const { currentPage, numPages, currentPath } = props.pageContext
    const isFirst = currentPage === 1
    const isLast = currentPage === numPages
    const prevPage = currentPage - 1 === 1 ? "" : (currentPage - 1).toString()
    const nextPage = (currentPage + 1).toString()
    let sp = "/";
    let s = "/";

    if (errors) {
        return (
            <Layout>
                <GraphQLErrorList errors={errors} />
            </Layout>
        );
    }
    const posts = props.data.allSanityEsStories.edges
    const language = "es";
    const keywords = ["Crema", "Articulo", "Blog", "Historias", "Freelancers", "Profesionistas Independientes"]
    const ogimg = "https://crema.cm/assets/img/640blurple.png";

    let toConcat= '';

    if(currentPage >1){
        toConcat =   currentPage + "/";
    }
    const ogurl = "https://crema.cm/es/blog/"+ toConcat;

    const canonical = [
        {
            rel: "canonical",
            href: "https://crema.cm/es/blog/" + toConcat
        },
        {
            rel: "alternate",
            href: "https://crema.cm/es/blog/" + toConcat,
            hrefLang: 'es'
        },
        {
            rel: "alternate",
            href: "https://crema.cm/es/blog/" + toConcat,
            hrefLang: 'x-default'
        }
    ];

   if(currentPage < 2 || currentPage === 2){
       sp = " ";
   }
    console.log(currentPath);
    return (
        <Layout language={language} topMenu="historias">
            <SEO lang={language} title="Crema Blog" description="Contenido y recursos creados por freelancers para freelancers de todo el mundo, unete a la comunidad de Crema y potencializa tu trabajo! " canonical={canonical} keywords={keywords} ogurl={ogurl} ogimg={ogimg} />
            <div className="resources-context-menu">
                <ul>
                    <li className="selected"><Link to="/es/blog/">Todas las Historias</Link></li>
                    <li><Link to="/es/blog/tutoriales/">Campus Crema</Link></li>
                    <li><Link to="/es/blog/tips/">Tips</Link></li>
                    <li><Link to="/es/blog/comunidad/">Comunidad</Link></li>
                    <li><Link to="/es/blog/compania/">Compañia</Link></li>
                    <li><Link to="/es/blog/herramientas/">Herramientas</Link></li>
                </ul>
            </div>
            <div className="stories">
                <ul>
                    {posts.map(({ node }) => {
                        return <li key={node.id}>
                                <StoryPreview {...node} directory={props.directory} language={language}/>
                            </li>
                    })}
                </ul>
            </div>
            <div className="pagination">
                {!isFirst && (
                    <Link to={currentPath  + prevPage + sp} rel="prev">
                        Previous
                    </Link>
                )}
                {!isLast && (
                    <Link to={currentPath  + nextPage + s} rel="next">
                        Next
                    </Link>
                )}
            </div>
        </Layout>
    );
};
export default esStoriesListBuilder;